import { IntelliconButton as AntdIntelliconButton } from "@empglabs/backoffice-ui-kit"

const IntelliconButton = props => {
  return <AntdIntelliconButton {...props} />
}

export default IntelliconButton
